// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeaderLists: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 14 20" width={width} height={height}>
            <path
                fill="currentColor"
                d="M0 2.656C0 1.673.784.875 1.75.875h10.5c.966 0 1.75.798 1.75 1.781v16.399c0 .453-.36.82-.806.82a.8.8 0 0 1-.448-.137L7 15.838l-5.746 3.9a.8.8 0 0 1-.448.137.813.813 0 0 1-.806-.82zm1.75-.594a.59.59 0 0 0-.583.594v15.712l5.509-3.737a.58.58 0 0 1 .648 0l5.51 3.737V2.656a.59.59 0 0 0-.584-.594z"
            />
        </svg>
    );
};

export default React.memo(HeaderLists);
